/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_SelectedInputs */



/**
* | output |
* | --- |
* | "No Events are selected. Please select one or more Events first" |
*
* @param {No_Events_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_events_selected = /** @type {((inputs?: No_Events_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement sélectionné. Veuillez sélectionner un ou plusieurs événements d'abord")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine Veranstaltungen ausgewählt. Bitte wählen Sie zuerst eine oder mehrere Veranstaltungen aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento selezionato. Seleziona prima uno o più eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мероприятия не выбраны. Пожалуйста, сначала выберите одно или несколько мероприятий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay eventos seleccionados. Seleccione uno o más eventos primero.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何活动。请先选择一个或多个活动。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントが選択されていません。まず1つ以上のイベントを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट चयनित नहीं है। कृपया पहले एक या अधिक इवेंट चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento foi selecionado. Selecione um ou mais eventos primeiro.")
	return /** @type {LocalizedString} */ ("No Events are selected. Please select one or more Events first")
});